import React, { Fragment } from 'react';
import { usePopupState, bindTrigger, bindPopover } from 'material-ui-popup-state/hooks';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Popper from '@material-ui/core/Popper';
import MenuListSkeleton from '../MenuList/Skeleton';
import { AppMenuIcon, MenuButton, MenuComponentWrapper, MenuWrapper } from './styles';
export var MultiAppMenuSkeleton = function MultiAppMenuSkeleton() {
  var menuItemsLoading = [{
    subMenuItems: 1,
    divider: true
  }, {
    subMenuItems: 2,
    divider: true
  }, {
    subMenuItems: 1,
    divider: true
  }, {
    subMenuItems: 0
  }, {
    subMenuItems: 0
  }];
  var popupState = usePopupState({
    variant: 'popover',
    popupId: 'appMenuPopper'
  });
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(MenuButton, bindTrigger(popupState), /*#__PURE__*/React.createElement(AppMenuIcon, null)), /*#__PURE__*/React.createElement(Popper, Object.assign({}, bindPopover(popupState), {
    placement: "bottom-start",
    transition: true,
    disablePortal: true,
    style: {
      zIndex: 9999
    }
  }), function (_ref) {
    var TransitionProps = _ref.TransitionProps;
    return /*#__PURE__*/React.createElement(Grow, Object.assign({}, TransitionProps, {
      id: "menu-list-grow",
      style: {
        transformOrigin: 'top left'
      }
    }), /*#__PURE__*/React.createElement(MenuWrapper, null, /*#__PURE__*/React.createElement(ClickAwayListener, {
      onClickAway: popupState.close
    }, /*#__PURE__*/React.createElement(MenuComponentWrapper, null, /*#__PURE__*/React.createElement(MenuListSkeleton, {
      listItems: menuItemsLoading
    })))));
  }));
};
export default MultiAppMenuSkeleton;